import { APIRoute } from '@/modules/utils'
import { Insurance } from '@/data'
import { HydraCollection } from 'emt-library'

export const OwnerRoute: APIRoute = {
  method: 'GET',
  path: `/v3/insurances/owner`,
}
export const BorrowerRoute: APIRoute = {
  method: 'GET',
  path: `/v3/insurances/borrower`,
}
export const PremiumRoute: APIRoute = {
  method: 'GET',
  path: `/v2/insurances/premium`,
}

export type Response = HydraCollection<Insurance>
